import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {requestPermission} from '../push-notifications'
//import { onUserLogin } from '../utils/serviceWorkerUtils';
import { updateUserInServiceWorker } from '../utils/serviceWorkerUtils';

function OTPpage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState({});
  const [otp, setOtp] = useState(['', '', '', '']); // Changed to 4 digits
  const [message, setMessage] = useState('');
  const [timer, setTimer] = useState(60);
  const inputRefs = useRef([]);
  const verifyOTP = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/verify-otp-and-login';
  const ConsumerLogin = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/customer-login';
  const [verifying, setVerifying] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  const { mobileNumber } = location.state;
  
  useEffect(() => {
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      setUserData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (index, value) => {
  if (!/^\d*$/.test(value)) return;

  // CASE 1: Browser auto-fills full OTP (e.g. "4829")
  if (value.length > 1) {
    const otpDigits = value.split('');
    const newOtp = [...otp];

    otpDigits.forEach((digit, i) => {
      if (index + i < newOtp.length) {
        newOtp[index + i] = digit;
      }
    });

    setOtp(newOtp);

    const nextIndex = Math.min(index + otpDigits.length, otp.length - 1);
    inputRefs.current[nextIndex]?.focus();
    return;
  }

  // CASE 2: Normal single digit typing
  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);

  if (value && index < otp.length - 1) {
    inputRefs.current[index + 1]?.focus();
  }
};



  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleOTP = async () => {
    if (mobileNumber.length === 10) {
      try {
        const res = await fetch(ConsumerLogin, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ mobile_number: mobileNumber }),
        });
        
        if (res.ok) {
          setTimer(60);
        } else {
          console.error('Login failed');
          setMessage("Try with valid number");
        }
      } catch (error) {
        console.error('Error:', error);
        clearStorageAndRedirectToHome();
      }
    }
  };

  function clearStorageAndRedirectToHome() {
    navigate("/bb/user/ErrorPage");
  }
  
  const handleVerifyOtp = async (forceLogin = false) => {
  const otpString = otp.join('');

  // ✅ frontend validation
  if (otpString.length !== 4) {
    setMessage("Please enter valid 4-digit OTP");
    return;
  }

  console.log("verify OTP request body:", {
    mobile_number: mobileNumber,
    otp: otpString,
    forceLogin
  });
  setVerifying(true);

  try {
    const response = await fetch(verifyOTP, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mobile_number: mobileNumber,
        otp: otpString,
        forceLogin
      }),
    });
    const data = await response.json();
    console.log("OTP verify response:", data);

    if (response.status === 409 && data.requireConfirmation) {
      setConfirmationMessage(data.message || 'Already logged in on another device. Continue?');
      setShowConfirmation(true);
      return;
    }

    // ❌ WRONG OTP → STOP
    if (!response.ok) {
      setMessage(data.message || "Invalid OTP");
      return;
    }

    // ✅ CORRECT OTP → CONTINUE
    localStorage.setItem('userData', JSON.stringify(data));
    sessionStorage.setItem('userData', JSON.stringify(data));
    sessionStorage.setItem('customerId', data._id);
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('hubId', data.hubId);
    sessionStorage.setItem('roleId', data.roleId);

    requestPermission();
    updateUserInServiceWorker(data._id);

    if (data.customer_status === 1) {
      navigate("/consumer/UserDetails");
    } else if (data.customer_status === 2) { 
      navigate("/consumer/Approved");
    } else if (data.customer_status === 3) {
      navigate("/consumer/HomeScreen");
    }

  } catch (error) {
    setMessage("Internal server error");
  
   } finally {
    setVerifying(false); // ✅ stop verifying
  }
};

  const handleConfirmVerify = () => {
    setShowConfirmation(false);
    handleVerifyOtp(true);
  };

  const handleCancelVerify = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="w-full flex justify-center items-center h-screen bg-white">
      <div className="w-full max-w-md px-6 py-0">
        {/* Logo and welcome text - reduced margin bottom */}
        {/* <div className="flex flex-col items-center mb-8">
          <img src={'/BB.png'} alt="Logo" className="h-20 w-30 mb-3" />
        </div> */}

        <div className="bg-white rounded-lg shadow-sm border border-[#D64541] overflow-hidden min-h-[400px] flex flex-col">
  <div className="px-4 py-6">
    <h3 className="text-xl font-semibold text-[#000000]">Enter Verification Code</h3>
    <p className="text-md text-[#00000] mt-4">
      We have sent a 4-digit code to <span className="font-bold text-md">+91 {mobileNumber}</span>
    </p>
  </div>
  
  <div className="px-4 pt-0.2 pb-6 flex-grow flex flex-col">
    {/* OTP header and input boxes moved to the top */}
    <h3 className="text-lg text-[#00000] mb-2">OTP Code</h3>
    
    <div className="flex justify-start items-start mb-6 ">
      {otp.map((value, index) => (
        <div key={index} className="flex items-center">
         <input
  ref={(el) => (inputRefs.current[index] = el)}
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  maxLength="1"
  autoComplete={index === 0 ? "one-time-code" : "off"}
  value={value}
  onChange={(e) => handleChange(index, e.target.value)}
  onKeyDown={(e) => handleKeyDown(e, index)}
  className="w-12 h-16 text-center text-xl font-semibold border border-[#D64541] rounded-md focus:border-[#D64541] focus:ring-0 focus:outline-none"
/>
          {/* Add hyphen between boxes, but not after the last one */}
          {index < otp.length - 1 && (
            <span className="mx-3 text-gray-400 text-xl">-</span>
          )}
        </div>
      ))}
    </div>

    {message && (
        <div className="text-red-700 px-3 py-2 text-sm font-semibold text-center">
          {message}
        </div>
    )}
    
    {/* Verify button */}
  <button
  onClick={() => handleVerifyOtp()}
  disabled={verifying}
  className={`w-full py-3 px-4 rounded-md text-md font-semibold transition duration-200 focus:outline-none focus:ring-2 focus:ring-[#D93025] focus:ring-opacity-50 mb-4 
    ${verifying 
      ? 'bg-gray-400 cursor-not-allowed text-white' 
      : 'bg-[#D64541] hover:bg-[#C20C0C] text-white'}`}
>
  {verifying ? 'Verifying...' : 'Verify OTP'}
</button>
    
    
    {/* Phone number change option */}
    <div className="text-center text-sm mb-4">
      <button
        className="text-[#3E1EDD]  hover:text-blue-800 hover:underline font-semibold"
        onClick={() => navigate('/consumer')}
      >
        Change phone number
      </button>
    </div>
    
    {/* Resend OTP option with improved timer handling */}
    <div className="text-center">
      {timer > 0 ? (
        <p className="text-sm text-[#827E7E] font-semibold">
          Didn't receive code? Resend in <span className="text-[#D93025] font-medium">{timer} seconds</span>
        </p>
      ) : (
        <p className="text-sm text-[#827E7E] font-semibold">
          Didn't receive code? <button className="text-[#3E1EDD] font-semibold" onClick={handleOTP}>Resend OTP</button>
        </p>
      )}
    </div>
    
    {/* Display message if any */}
    
  </div>
</div>
 

      {showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 mx-4 max-w-sm w-full">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Confirm Login</h3>
              <p className="text-sm text-gray-600 mb-4">{confirmationMessage}</p>
              <div className="flex space-x-3">
                <button
                  onClick={handleCancelVerify}
                  className="flex-1 py-2 px-4 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md transition duration-300"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmVerify}
                  className="flex-1 py-2 px-4 bg-[#D64541] hover:bg-[#C20C0C] text-white rounded-md transition duration-300"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

        </div>
      
      </div>
  
  );
  
}

export default OTPpage;
